import React from "react";
import footer from "../../Assets/footer/footerbg.svg";
import footer2 from "../../Assets/footer/footer2.svg";
import footer2M from "../../Assets/footer/footerbBg.png";
// import footer from "../../assets/footer/footerbg.svg";
import styles from "./footer.module.css";
import iconsfac from "../../Assets/footer/Facebook.svg";
import iconsinsta from "../../Assets/footer/Instgram.svg";
import iconsyoutube from "../../Assets/footer/Youtube.svg";
import iconsloc from "../../Assets/footer/Location.svg";
import iconsmail from "../../Assets/footer/Mail.svg";
import iconscall from "../../Assets/footer/Contact.svg";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function Footer() {
  const handleSocialMediaClick = (link) => {
    window.open(link, "_blank", "noopener,noreferrer");
  };

  return (
    <footer
      className={styles.footerContainer}
      role="contentinfo"
      aria-label="Site footer"
    >
      <Helmet>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "MyBurgo",
              "url": "https://myburgo.com",
              "logo": "https://myburgo.com/logo.png",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91 7710048212",
                "contactType": "customer service",
                "email": "hello@myburgo.com",
                "areaServed": "IN",
                "availableLanguage": ["en", "hi"]
              },
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "B-303, Mangalya, Marol Maroshi Road, Andheri (East)",
                "addressLocality": "Mumbai",
                "addressRegion": "Maharashtra",
                "postalCode": "400059",
                "addressCountry": "IN"
              },
              "sameAs": [
                "https://www.facebook.com/profile.php?id=61565026686788",
                "https://www.instagram.com/myburgo_app?igsh=dzR3OHkxbG9kaXBu",
                "https://youtube.com/@myburgo_app?si=7uSggIhoSZOBMppR"
              ]
            }
          `}
        </script>
      </Helmet>

      <div className={styles.footerLinks}>
        <nav
          className={styles.socialmediaLinks}
          aria-label="Social media and policies"
        >
          <div className={styles.socialIcon}>
            <button
              onClick={() =>
                handleSocialMediaClick(
                  "https://www.facebook.com/profile.php?id=61565026686788"
                )
              }
              aria-label="Visit our Facebook page"
              className={styles.socialButton}
            >
              <img src={iconsfac} alt="Facebook" width="24" height="24" />
            </button>

            <Link
              className={`${styles.plink} ${styles.hidemobile}`}
              to="/privacy-policy"
            >
              Privacy Policy
            </Link>
          </div>
          <div className={styles.socialIcon}>
            <button
              onClick={() =>
                handleSocialMediaClick(
                  "https://www.instagram.com/myburgo_app?igsh=dzR3OHkxbG9kaXBu"
                )
              }
              aria-label="Visit our Instagram page"
              className={styles.socialButton}
            >
              <img src={iconsinsta} alt="Instagram" width="24" height="24" />
            </button>

            <Link
              className={`${styles.plink} ${styles.hidemobile}`}
              to="/terms-and-condition"
            >
              Terms And Condition
            </Link>
          </div>
          <div className={styles.socialIcon}>
            <button
              onClick={() =>
                handleSocialMediaClick(
                  "https://youtube.com/@myburgo_app?si=7uSggIhoSZOBMppR"
                )
              }
              aria-label="Visit our YouTube channel"
              className={styles.socialButton}
            >
              <img src={iconsyoutube} alt="YouTube" width="24" height="24" />
            </button>
            <Link
              className={`${styles.plink} ${styles.hidemobile}`}
              to="/cancellation-and-refund-policy"
            >
              Cancellation and Refund Policy
            </Link>
          </div>
        </nav>

        <section className={styles.countactUs} aria-label="Contact information">
          <div className={styles.footerBox}>
            <div className={styles.footerImgC}>
              <img src={iconscall} alt="Phone" width="24" height="24" />
            </div>
            <div>
              <h6>Phone Number</h6>
              <h5>
                <a
                  href="tel:+917710048212"
                  aria-label="Call us at +91 7710048212"
                >
                  +91 7710048212
                </a>
              </h5>
            </div>
          </div>
          <div className={styles.footerBox}>
            <div className={styles.footerImgC}>
              <img src={iconsmail} alt="Email" width="24" height="24" />
            </div>
            <div>
              <h6>Email Address</h6>
              <h5>
                <a
                  href="mailto:hello@myburgo.com"
                  aria-label="Email us at hello@myburgo.com"
                >
                  hello@myburgo.com
                </a>
              </h5>
            </div>
          </div>
          <div className={styles.footerBox}>
            <div className={styles.footerImgC}>
              <img src={iconsloc} alt="Location" width="24" height="24" />
            </div>
            <div>
              <h6>Our Address</h6>
              <address>
                <h5>
                  B-303, Mangalya, Marol Maroshi Road, Andheri ( East ),
                  Mumbai-400059 India.
                </h5>
              </address>
            </div>
          </div>
        </section>
      </div>

      <nav className={styles.pageLink} aria-label="Legal pages">
        <Link className={styles.plink} to="/privacy-policy">
          Privacy Policy
        </Link>
        <Link className={styles.plink} to="/terms-and-condition">
          Terms And Condition
        </Link>
        <Link className={styles.plink} to="/cancellation-and-refund-policy">
          Cancellation and Refund Policy
        </Link>
      </nav>

      <div className={styles.footerbottom} aria-hidden="true">
        <img src={footer2} alt="" />
      </div>
      <div className={styles.fBformob} aria-hidden="true">
        <img src={footer2M} alt="" />
      </div>
      <div className={styles.copyrighttext}>
        © {new Date().getFullYear()} Velvin Technologies Pvt Ltd. All rights
        Reserved
      </div>
    </footer>
  );
}

export default Footer;
